<div class="row mb-3 align-items-center">
    <label class="col-md-8 col-form-label"> {{ model.complaintsQuestion1OptionGroup.name }} </label>
    <div class="col-md-4">
        <pace-core-radio-input
            [(model)]="model.complaintsQuestion1OptionGroup"
            [parentForm]="parentForm"
            (valueChange)="optionChange()"
        >
        </pace-core-radio-input>
    </div>
</div>
<div class="row mb-3 align-items-center">
    <label class="col-md-8 col-form-label"> {{ model.complaintsQuestion2OptionGroup.name }} </label>
    <div class="col-md-4">
        <pace-core-radio-input
            [(model)]="model.complaintsQuestion2OptionGroup"
            [parentForm]="parentForm"
            (valueChange)="optionChange()"
        >
        </pace-core-radio-input>
    </div>
</div>
<div class="row mb-3 align-items-center">
    <label class="col-md-8 col-form-label"> {{ model.complaintsQuestion3OptionGroup.name }} </label>
    <div class="col-md-4">
        <pace-core-radio-input
            [(model)]="model.complaintsQuestion3OptionGroup"
            [parentForm]="parentForm"
            (valueChange)="optionChange()"
        >
        </pace-core-radio-input>
    </div>
</div>
<div class="row mb-3 align-items-center">
    <label class="col-md-8 col-form-label"> {{ model.complaintsQuestion4OptionGroup.name }} </label>
    <div class="col-md-4">
        <pace-core-radio-input
            [(model)]="model.complaintsQuestion4OptionGroup"
            [parentForm]="parentForm"
            (valueChange)="optionChange()"
        >
        </pace-core-radio-input>
    </div>
</div>
<div
    class="row mb-3 align-items-center"
    *ngIf="model.showCyberSecurityComplaintQuestion && model.complaintsQuestion5OptionGroup"
>
    <label class="col-md-8 col-form-label"> {{ model.complaintsQuestion5OptionGroup.name }} </label>
    <div class="col-md-4">
        <pace-core-radio-input
            [(model)]="model.complaintsQuestion5OptionGroup"
            [parentForm]="parentForm"
            (valueChange)="optionChange()"
        >
        </pace-core-radio-input>
    </div>
</div>

<ng-container *ngIf="model.showQuestionnaireLink()">
    <div class="row mb-3 align-items-center">
        <ng-container *ngIf="isPacePWA && !isPaceOnline">
            <textarea
                class="form-control no-pointer-events position-absolute opacity-0"
                [attr.aria-label]="'CONFIRMATION_COMPLAINTS_LINK_TO_COPY_LABEL' | translate"
                #linkToCopy
            >
                {{ strings.questionnaireLink }}
            </textarea>
            <span class="col col-12">
                <a
                    class="btn btn-warning paceCoreLink pace-link w-100"
                    (click)="openInEdge()"
                    target="_blank"
                    translate="CONFIRMATION_COMPLAINTS_ADDITIONAL_QUESTIONNAIRE_TITLE"
                >
                    <fa-icon [icon]="faClock" class="ps-1 fa-xs"></fa-icon>
                </a>
            </span>
            <span
                class="col col-12 pace-link d-flex justify-content-center my-2"
                [ngClass]="{ 'text-success': isCopied, 'text-primary': !isCopied }"
                [ngxClipboard]="linkToCopy"
                (cbOnSuccess)="onClipboardCopySuccess($event)"
            >
                {{ clipboardCopyButtonLabel }}
            </span>
            <span class="col col-12 offset-lg-2 col-lg-8 col-form-label">
                <div
                    class="form-control-plaintext text-center"
                    translate="CONFIRMATION_COMPLAINTS_ADDITIONAL_QUESTIONNAIRE_HELPER_TEXT_FOR_TICKET_NUMBER"
                ></div>
            </span>
        </ng-container>
        <ng-container *ngIf="isPaceOnline">
            <span class="col col-12">
                <button
                    class="btn btn-warning w-100"
                    translate="CONFIRMATION_COMPLAINTS_ADDITIONAL_QUESTIONNAIRE_PACEONLINE_TEXT"
                ></button>
            </span>
        </ng-container>
    </div>
</ng-container>
